import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { useLanguageContext } from '@/features/language';
import { BLACK_4, useThemeContext } from '@/features/theme';
import { LanguageSelect } from './language-select';

const StyledFooter = styled.div(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '640px',
    gap: '16px',
  };
});

const FooterMainInfo = styled.div(() => {
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: '16px',
  };
});

const PoweredByLink = styled.a(() => {
  const theme = useThemeContext();
  return {
    textDecoration: 'none',
    fontSize: '12px',
    fontWeight: '400',
    color: BLACK_4,
    '&:hover': { color: theme.primaryColor },
  };
});

interface IFooterProps {
  className?: string;
}

export const Footer = ({
  children,
  className,
}: PropsWithChildren<IFooterProps>) => {
  const { language, onLanguageChange } = useLanguageContext();
  return (
    <StyledFooter className={className}>
      {children}
      <FooterMainInfo>
        <PoweredByLink href="https://workee.net" target="_blank">Powered by Workee</PoweredByLink>
        <LanguageSelect
          value={language}
          onChange={onLanguageChange}
        />
      </FooterMainInfo>
    </StyledFooter>
  );
};
